import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import MainMenu from "./MainMenu";
import Routes from "../../utils/routes";
import styles from "./sidebar-jss";
import simbolo from "../../styles/images/concilia-solucoes/conciliador/simbolo-conciliador-branco.png";
import "../../styles/custom/SidebarContent.css";
import IsVisSPCContext from "../CRUD/isVisContext";

interface Props {
  classes: any;
  turnDarker?: boolean;
  drawerPaper?: boolean;
  expandidoPorHover?: boolean;
  temporario?: boolean;
  aoFechar?: React.ReactEventHandler<{}>;
  leftSidebar?: boolean;
  loadTransition?: (isLoaded: boolean) => void;
  status: String;
  anchorEl: HTMLElement | ((element: HTMLElement) => HTMLElement) | null | undefined;
  openMenuStatus: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  closeMenuStatus: (event: React.SyntheticEvent<{}, Event>) => void;
  changeStatus: (status: String) => void;
  isLogin?: boolean;
}

interface State {
  transform: number;
  isLogin: boolean;
}

class SidebarContent extends React.Component<Props, State> {
  state = {
    transform: 0,
    nome: "Marcelo",
    isLogin: true,
  };

  componentDidMount = () => {
    // Scroll content to top
    const mainContent = document.getElementById("sidebar");
    mainContent!.addEventListener("scroll", this.handleScroll);
  };

  componentWillUnmount() {
    const mainContent = document.getElementById("sidebar");
    mainContent!.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (event: any) => {
    const scroll = event.target!.scrollTop;
    this.setState({
      transform: scroll,
    });
  };

  // a gaveta temporaria e um Modal: aberta ela trava a rolagem do body, e o link da rota atual nem troca a pagina
  fechaAoNavegar = (evento: React.MouseEvent<HTMLElement>) => {
    const { temporario, aoFechar } = this.props;
    if (temporario && aoFechar && (evento.target as HTMLElement).closest("a[href]")) {
      aoFechar(evento);
    }
  };

  render() {
    const { classes, turnDarker, drawerPaper, expandidoPorHover, leftSidebar, temporario, aoFechar } = this.props;
    const { isLogin } = this.state;

    // A gaveta temporaria so existe aberta: nao tem o modo trilho estreito que o menu
    // permanente assume quando drawerPaper e falso.
    const expandido = temporario || drawerPaper;

    return (
      <div
        className={classNames(
          temporario ? classes.drawerInnerMobile : classes.drawerInner,
          !expandido && classes.drawerPaperClose,
          !expandido && expandidoPorHover && classes.railExpandido
        )}
        id="drawerInner"
        onClick={this.fechaAoNavegar}
      >
        {temporario && aoFechar && (
          <div className={classes.drawerHeaderOpen}>
            <IconButton className={classes.botaoFechar} aria-label="Fechar menu" onClick={aoFechar}>
              <CloseIcon />
            </IconButton>
          </div>
        )}
        <div
          id="sidebar"
          className={classNames(classes.menuContainer, leftSidebar && classes.rounded, isLogin && classes.withProfile)}
        >
          <NavLink
            to={Routes.home.route}
            aria-label={"Página inicial"}
            className={classNames(classes.brand, classes.brandBar, turnDarker && classes.darker)}
          >
            <img src={simbolo} alt="" />
          </NavLink>
          <IsVisSPCContext.Consumer>
            {(value) => {
              if (value && value.isVisSPC === "vis") {
                return null;
              }
              return <MainMenu />;
            }}
          </IsVisSPCContext.Consumer>
        </div>
      </div>
    );
  }
}

export default withStyles(styles as any)(SidebarContent);
